export default (state = {
    questionCategory: [],
    allQuestionCategory: [],
    totalItems: 0,
    currentPage: 1,
    pageCount: 1,
    pageSize: localStorage.getItem("questionCategoryPageSize") ? Number(localStorage.getItem("questionCategoryPageSize")) : 30
}, action) => {
    switch (action.type) {
        case "SET_QUESTION_CATEGORY":
            return {
                ...state,
                questionCategory: action.payload,
                currentPage: action.currentPage,
                sortBy: action.sortBy,
                sortOrder: action.sortOrder,
                totalItems: action.totalItems,
                pageCount: action.pageCount,
            }
        case "SET_ALL_QUESTION_CATEGORY":
            return {
                ...state,
                allQuestionCategory: action.payload
            }
        case "CHANGE_PAGE_SIZE_QUESTION_CATEGORY":
            return {
                ...state,
                pageSize: action.payload
            }
        default:
            return state
    }
}